module.exports = __webpack_public_path__ + "static/media/MedicationSearch.70749e11.svg";